/**
 * This settings is to gate the phone support functionality.
 * https:www.figma.com/design/HfEQVACpqhZIoLXyt0NAqF/Universal-Insider-Framework-(retailer)?node-id=21447-15190&t=7VnUoGGmBME0XNC6-4
 */ export var INSIDER_PHONE_SUPPORT_ENABLED = 'INSIDER_PHONE_SUPPORT_ENABLED';
